import { Component, Input } from '@angular/core';

const KNOWN_TYPES = ['bar-h', 'bar-v', 'line', 'pie', 'donut', 'rows', 'stacked', 'table'];

/** Small inline icons for chart type toggles (pie, bar, line, etc.). */
@Component({
  selector: 'app-br-chart-type-icon',
  templateUrl: './chart-type-icon.component.html'
})
export class BrChartTypeIconComponent {
  @Input() type: string;

  get resolvedType(): string {
    return KNOWN_TYPES.includes(this.type) ? this.type : 'bar-h';
  }
}
